<button mat-button fxFill class="menu-button" [routerLink]="link" [attr.data-testid]="link"
	[routerLinkActive]="showActiveLink ? 'active' : ''" (click)="closeIfSmall()">
	<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem" class="pad-05">
		<mat-icon fxShow="true" fxHide.gt-md [matTooltip]="text">{{ icon }}</mat-icon>
		<mat-icon fxHide="true" fxShow.gt-md>{{ icon }}</mat-icon>
		<div fxHide="true" fxShow.gt-md class="font-11">{{ text }}</div>
	</div>
</button>